import { useEffect, useState } from 'react'
import { Zap } from 'lucide-react'
import {
  getTimeOverrideOffsetSeconds,
  isTimeOverrideEnabled,
  onTimeOverrideChange,
  realNowMs,
} from '@/lib/timeOverride'

/**
 * Compact topbar pill showing the shifted clock — only visible when the
 * tester has set a non-zero offset, so the badge stays out of the way
 * during normal use. Click is a no-op (the launcher hotkey handles input);
 * could be wired later to open the dialog if useful.
 */
export const TimeOverrideBadge = () => {
  const enabled = isTimeOverrideEnabled()
  const [offset, setOffset] = useState(() => getTimeOverrideOffsetSeconds())
  const [tick, setTick] = useState(0)

  useEffect(() => onTimeOverrideChange(() => setOffset(getTimeOverrideOffsetSeconds())), [])

  useEffect(() => {
    if (!enabled || offset === 0) return
    const id = setInterval(() => setTick((t) => t + 1), 1000)
    return () => clearInterval(id)
  }, [enabled, offset])

  if (!enabled || offset === 0) return null

  const shifted = new Date(realNowMs() + offset * 1000)
  const label = shifted.toLocaleString(undefined, {
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })

  // tick keeps the badge label refreshing every second
  void tick

  return (
    <div
      title="Tester clock is shifted — press Ctrl+Shift+K to adjust"
      className="hidden md:inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2.5 py-1 font-mono text-[11px] font-bold text-amber-800"
    >
      <Zap size={12} />
      {label}
    </div>
  )
}
